import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course04 from "../../../course/course-04/course";
import lesson0402 from "../../../lesson/course-04/lesson-02/lesson";
import lesson0403 from "../../../lesson/course-04/lesson-03/lesson";
import lesson0404 from "../../../lesson/course-04/lesson-04/lesson";
import lesson0407 from "../../../lesson/course-04/lesson-07/lesson";
import lesson0409 from "../../../lesson/course-04/lesson-09/lesson";
import lesson0415 from "../../../lesson/course-04/lesson-15/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "bbc7665e-d7d7-4641-b7f4-8ce230ce5a43",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0402),
    lesson: lesson0402,
  },
  {
    id: "dab056b8-22e5-4f1f-9515-57075920a858",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0403),
    lesson: lesson0403,
  },
  {
    id: "efc76e9b-df2c-4d4a-a524-002a98106cb6",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0404),
    lesson: lesson0404,
  },
  {
    id: "1e1a57ec-077e-4d7f-b5db-831eb5f03b3b",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0407),
    lesson: lesson0407,
  },
  {
    id: "79265434-faf6-49a7-9b65-5cbe6d7416c8",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0409),
    lesson: lesson0409,
  },
  {
    id: "67206eca-c95a-4008-9fae-855ca37d3fd6",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0415),
    lesson: lesson0415,
  },
];

export default lessonLinks;
